import React from 'react';
import Banner from './Banner';
import AboutThree from './AboutThree';
import ServicesFour from './ServicesFour';
import CTAThree from './CTAThree';
import ProjectThree from './ProjectThree';
import CounterTwo from './CounterTwo';
import TestimonialThree from './TestimonialThree';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import WhyWe from './WhyWe';
import VideoOne from './VideoOne';
import WorkProcess from './WorkProcess';
import BlogThree from './BlogThree';


const HomeThreeMain = () => {
	return (
		<>
			<Banner />
			<AboutThree />
			<ServicesFour />
			<CTAThree />
			<ProjectThree />
			<CounterTwo />
			<SlidingTextOne />
			<TestimonialThree />
			<WhyWe />
			<VideoOne />
			<WorkProcess />
			<BlogThree />			
		</>
	);
}

export default HomeThreeMain;
